import { ORDER_TYPES } from './index';
import { PriceBookContext } from '../../Context';

const NEW_CUSTOMER_PATH_V1 = '/quotes/new-customer/calculation';
const NEW_CUSTOMER_PATH_V2 = '/v2/quotes/new-customer/calculation';

function makePathWithVersions(versions) {
  return new Proxy(versions, {
    get(target, prop) {
      if (prop in target) {
        return target[prop];
      }

      if (prop === Symbol.toPrimitive || prop === 'toString') {
        return () => (PriceBookContext.model.isSupportsCommUnity ? NEW_CUSTOMER_PATH_V2 : NEW_CUSTOMER_PATH_V1);
      }

      return NEW_CUSTOMER_PATH_V1;
    },
  });
}

export const API_QUOTE_CALCULATION_PATHS = {
  [ORDER_TYPES.NEW_CUSTOMER]: makePathWithVersions({
    V1: NEW_CUSTOMER_PATH_V1,
    V2: NEW_CUSTOMER_PATH_V2,
  }),
  [ORDER_TYPES.NEW_LOCATIONS]: '/quotes/new-location/calculation',
  [ORDER_TYPES.ADD_ON]: '/quotes/add-on/calculation',
  [ORDER_TYPES.REWRITE]: '/quotes/rewrite/calculation',
  [ORDER_TYPES.REDUCTION]: '/quotes/calculation',
};
